module.exports = __webpack_public_path__ + "img/0Q3A4226_FoamcoreMatted.357c3a18.jpg";